import { standardBorder } from "./borders";

export const borderedWithWhiteBackground = {
  ...standardBorder,
  p: "1rem",
  backgroundColor: "common.white",
};
